"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.media");

var _Theme2 = require("../../Theme/Theme.spacing");

var _Theme3 = require("../../Theme/Theme.display");

var _Theme4 = require("../../Theme/Theme.variables");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["box-shadow: ", ";"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["box-shadow: ", ";"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["box-shadow: ", ";"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["box-shadow: ", ";"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["box-shadow: ", ";"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n        margin-left: -16px;\n        margin-right: -16px;\n     "]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n      box-sizing: border-box;\n      margin-left: -8px;\n      margin-right: -8px;\n      ", ";\n    "]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["padding-left:16px;padding-right:16px;"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["padding-left:0;padding-right:0;"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["padding-left:16px;padding-right:16px;"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["padding-left:0;padding-right:0;"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["padding-left:16px;padding-right:16px;"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["padding-left:0;padding-right:0;"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["padding-left:16px;padding-right:16px;"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["padding-left:0;padding-right:0;"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["padding-left:8px;padding-right:8px;"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["padding-left:0;padding-right:0;"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["padding-left:16px;padding-right:16px;"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n      padding-left: 8px;\n      padding-right: 8px;\n      ", ";\n    "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["justify-content: ", ";"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["justify-content: ", ";"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["justify-content: ", ";"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["justify-content: ", ";"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["justify-content: ", ";"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["align-items: ", ";"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["align-items: ", ";"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["align-items: ", ";"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["align-items: ", ";"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["align-items: ", ";"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["border-color: ", ";"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["border-color: ", ";"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["border-color: ", ";"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["border-color: ", ";"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["border-color: ", ";"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["border-width: ", "px;"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["flex-flow: ", ";"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["flex-flow: ", ";"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["flex-flow: ", ";"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["flex-flow: ", ";"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["flex-flow: ", ";"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["width: ", "%;"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["width: ", "%;"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["width: ", "%;"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["width: ", "%;"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["width: ", "%;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* MODULE SPECIFIC STYLING */\n\n  box-sizing: border-box;\n\n  ", ";\n\n  /* Columns and Flex */\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Flex Flow */\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Border */\n  border: solid 0px transparent;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Flex Layout (Align and Justify)*/\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Background Color */\n  ", ";\n\n  /* IMPORT SHARED STYLING */\n  /* Display */\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  \n\n  ", "\n\n  /* Dynamic Spacing */\n  ", ";\n\n  /* Shadows */\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledBox = _styledComponents.default.div(_templateObject(), function (props) {
  return props.isSticky && "\n    position: sticky;\n    top: 0;\n  ";
}, function (props) {
  return props.flex && "flex: ".concat(props.flex, ";");
}, function (props) {
  return (props.column || props.column === 0) && "width: ".concat(props.column / 12 * 100, "%;");
}, function (props) {
  return (props.columnXs || props.columnXs === 0) && _Theme.media.xs(_templateObject2(), props.columnXs / 12 * 100);
}, function (props) {
  return (props.columnSm || props.columnSm === 0) && _Theme.media.sm(_templateObject3(), props.columnSm / 12 * 100);
}, function (props) {
  return (props.columnMd || props.columnMd === 0) && _Theme.media.md(_templateObject4(), props.columnMd / 12 * 100);
}, function (props) {
  return (props.columnLg || props.columnLg === 0) && _Theme.media.lg(_templateObject5(), props.columnLg / 12 * 100);
}, function (props) {
  return (props.columnXl || props.columnXl === 0) && _Theme.media.xl(_templateObject6(), props.columnXl / 12 * 100);
}, function (props) {
  return props.flexFlow && "flex-flow: ".concat(props.flexFlow, ";");
}, function (props) {
  return props.flexFlowXs && _Theme.media.xs(_templateObject7(), props.flexFlowXs);
}, function (props) {
  return props.flexFlowSm && _Theme.media.sm(_templateObject8(), props.flexFlowSm);
}, function (props) {
  return props.flexFlowMd && _Theme.media.md(_templateObject9(), props.flexFlowMd);
}, function (props) {
  return props.flexFlowLg && _Theme.media.lg(_templateObject10(), props.flexFlowLg);
}, function (props) {
  return props.flexFlowXl && _Theme.media.xl(_templateObject11(), props.flexFlowXl);
}, function (props) {
  return props.borderWidth !== undefined && "border-width: ".concat(_Theme4.borderWidths[props.borderWidth], "px;");
}, function (props) {
  return props.borderWidthXs !== undefined && _Theme.media.xs(_templateObject12(), _Theme4.borderWidths[props.borderWidthXs]);
}, function (props) {
  return props.borderWidthSm !== undefined && _Theme.media.sm(_templateObject13(), _Theme4.borderWidths[props.borderWidthSm]);
}, function (props) {
  return props.borderWidthMd !== undefined && _Theme.media.md(_templateObject14(), _Theme4.borderWidths[props.borderWidthMd]);
}, function (props) {
  return props.borderWidthLg !== undefined && _Theme.media.lg(_templateObject15(), _Theme4.borderWidths[props.borderWidthLg]);
}, function (props) {
  return props.borderWidthXl !== undefined && _Theme.media.xl(_templateObject16(), _Theme4.borderWidths[props.borderWidthXl]);
}, function (props) {
  return props.borderColor && "border-color: ".concat((0, _Theme4.variables)(props)[props.borderColor], ";");
}, function (props) {
  return props.borderColorXs && _Theme.media.xs(_templateObject17(), (0, _Theme4.variables)(props)[props.borderColorXs]);
}, function (props) {
  return props.borderColorSm && _Theme.media.sm(_templateObject18(), (0, _Theme4.variables)(props)[props.borderColorSm]);
}, function (props) {
  return props.borderColorMd && _Theme.media.md(_templateObject19(), (0, _Theme4.variables)(props)[props.borderColorMd]);
}, function (props) {
  return props.borderColorLg && _Theme.media.lg(_templateObject20(), (0, _Theme4.variables)(props)[props.borderColorLg]);
}, function (props) {
  return props.borderColorXl && _Theme.media.xl(_templateObject21(), (0, _Theme4.variables)(props)[props.borderColorXl]);
}, function (props) {
  return props.alignItems && "align-items: ".concat(props.alignItems, ";");
}, function (props) {
  return props.alignItemsXs && _Theme.media.xs(_templateObject22(), props.alignItemsXs);
}, function (props) {
  return props.alignItemsSm && _Theme.media.sm(_templateObject23(), props.alignItemsSm);
}, function (props) {
  return props.alignItemsMd && _Theme.media.md(_templateObject24(), props.alignItemsMd);
}, function (props) {
  return props.alignItemsLg && _Theme.media.lg(_templateObject25(), props.alignItemsLg);
}, function (props) {
  return props.alignItemsXl && _Theme.media.xl(_templateObject26(), props.alignItemsXl);
}, function (props) {
  return props.justifyContent && "justify-content: ".concat(props.justifyContent, ";");
}, function (props) {
  return props.justifyContentXs && _Theme.media.xs(_templateObject27(), props.justifyContentXs);
}, function (props) {
  return props.justifyContentSm && _Theme.media.sm(_templateObject28(), props.justifyContentSm);
}, function (props) {
  return props.justifyContentMd && _Theme.media.md(_templateObject29(), props.justifyContentMd);
}, function (props) {
  return props.justifyContentLg && _Theme.media.lg(_templateObject30(), props.justifyContentLg);
}, function (props) {
  return props.justifyContentXl && _Theme.media.xl(_templateObject31(), props.justifyContentXl);
}, function (props) {
  return props.backgroundColor && "background-color: ".concat((0, _Theme4.variables)(props)[props.backgroundColor]);
}, function (props) {
  return (0, _Theme3.display)(props);
}, function (props) {
  return props.extendsFrom === 'column' && props.column !== 0 && (0, _styledComponents.css)(_templateObject32(), _Theme.media.sm(_templateObject33()));
}, function (props) {
  return props.extendsFrom === 'column' && (props.columnXs === 0 ? _Theme.media.xs(_templateObject34()) : props.columnXs !== undefined && _Theme.media.xs(_templateObject35()));
}, function (props) {
  return props.extendsFrom === 'column' && (props.columnSm === 0 ? _Theme.media.sm(_templateObject36()) : (props.columnXs !== 0 && props.columnXs !== undefined || props.columnSm !== undefined) && _Theme.media.sm(_templateObject37()));
}, function (props) {
  return props.extendsFrom === 'column' && (props.columnMd === 0 ? _Theme.media.md(_templateObject38()) : props.columnMd !== undefined && _Theme.media.md(_templateObject39()));
}, function (props) {
  return props.extendsFrom === 'column' && (props.columnLg === 0 ? _Theme.media.lg(_templateObject40()) : props.columnLg !== undefined && _Theme.media.lg(_templateObject41()));
}, function (props) {
  return props.extendsFrom === 'column' && (props.columnXl === 0 ? _Theme.media.xl(_templateObject42()) : props.columnXl !== undefined && _Theme.media.xl(_templateObject43()));
}, function (props) {
  return props.extendsFrom === 'row' && (0, _styledComponents.css)(_templateObject44(), _Theme.media.sm(_templateObject45()));
}, function (props) {
  return (0, _Theme2.spacing)(props);
}, function (props) {
  return props.shadowLevel && "box-shadow: ".concat((0, _Theme4.variables)(props).shadows[props.shadowLevel], ";");
}, function (props) {
  return props.shadowLevelXs && _Theme.media.xs(_templateObject46(), (0, _Theme4.variables)(props).shadows[props.shadowLevelXs]);
}, function (props) {
  return props.shadowLevelSm && _Theme.media.sm(_templateObject47(), (0, _Theme4.variables)(props).shadows[props.shadowLevelSm]);
}, function (props) {
  return props.shadowLevelMd && _Theme.media.md(_templateObject48(), (0, _Theme4.variables)(props).shadows[props.shadowLevelMd]);
}, function (props) {
  return props.shadowLevelLg && _Theme.media.lg(_templateObject49(), (0, _Theme4.variables)(props).shadows[props.shadowLevelLg]);
}, function (props) {
  return props.shadowLevelXl && _Theme.media.xl(_templateObject50(), (0, _Theme4.variables)(props).shadows[props.shadowLevelXl]);
}, function (props) {
  return props.polaroid && "\n      border: ".concat(_Theme4.space[2], "px solid ").concat((0, _Theme4.variables)(props).white, ";\n      display: inline-block;\n      img {display:block;}\n    ");
}, function (props) {
  return props.polaroid && _Theme.media.xs(_templateObject51(), _Theme4.space[3]);
}, _styledSystem.space);

exports.StyledBox = StyledBox;